import React from 'react';
import { motion } from 'framer-motion';
const features = [{
  title: 'AVANCE RÁPIDO',
  image: 'https://cdn.magicpatterns.com/uploads/13D2iajdA5PrCYVEtuL6DX/Imagen_23-3-26_a_las_1.40_p._m..jpg'
}, {
  title: 'INFORMACIÓN DE VALOR',
  image: 'https://cdn.magicpatterns.com/uploads/5iepTBajxdwvdhgZHWgdoF/Imagen_23-3-26_a_las_1.50_p._m..jpg'
}, {
  title: 'PLANTILLAS LISTAS',
  image: 'https://cdn.magicpatterns.com/uploads/9cDCxZF53hsuJbu8fWmRcd/Imagen_23-3-26_a_las_1.58_p._m..jpg'
}];
export function TestimonialsFeatures() {
  return <section className="w-full bg-brand-bg pb-8 md:pb-10 px-6" data-id="element-441">
      <div className="max-w-4xl mx-auto flex flex-col gap-16 md:gap-24" data-id="element-442">
        {features.map((feature, index) => <motion.div key={feature.title} className="flex flex-col items-center" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: index * 0.1
      }} data-id="element-443">
            {/* Title with green glow */}
            <div className="relative" data-id="element-444">
              <div className="absolute left-1/2 -translate-x-1/2 top-[40%] w-[200px] md:w-[350px] h-[6px] bg-[#1fa855]/30 blur-[20px] rounded-full pointer-events-none" data-id="element-445" />
              <div className="absolute left-1/2 -translate-x-1/2 top-[40%] w-[120px] md:w-[200px] h-[3px] bg-[#1fa855]/50 blur-[8px] rounded-full pointer-events-none" data-id="element-446" />
              <h3 className="text-3xl md:text-5xl lg:text-6xl font-extrabold italic text-gray-900 relative z-10 tracking-tight" data-id="element-447">
                {feature.title}
              </h3>
            </div>
            <div className="w-full overflow-hidden" data-id="element-448">
              <img src={feature.image} alt={`Testimonio - ${feature.title}`} className="w-full h-auto object-cover" data-id="element-449" />
            </div>
          </motion.div>)}
      </div>
    </section>;
}